module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.scss
// module id = ./src/app/components/footer/footer.scss
// module chunks = main